module.exports = __webpack_public_path__ + "medlogin.55e9f9e29618e8c2f158.png";


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/assets/img/ycm/medlogin.png
// module id = ../../../../../src/assets/img/ycm/medlogin.png
// module chunks = main